import React from 'react';
import axios from 'axios';
import { createRoot } from 'react-dom/client';
// import '../stylesheets/bootstrap.min.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

// import './stylesheets/font-awesome.min.css';
import './index.css';
import './responsive.css';
import 'antd/dist/reset.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { logoutUser } from './reducers/userSlice';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_BASE_URL;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      store.dispatch(logoutUser());
      delete axios.defaults.headers.common.Authorization;
    }
    return Promise.reject(error);
  },
);

const root = createRoot(document.getElementById("root"));
root.render(<App />);
reportWebVitals();